import "./theme.css";
import React, { useState, useEffect } from "react";
import "./App.css";
import Chatbot from "./components/Chatbot";
import RequirePlan from "./components/RequirePlan";
import RequireAdminRole from "./components/RequireAdminRole";
import RequireRole from "./components/RequireRole";
import Sidebar from "./Product/sidebar";
import AppTopbar from "./components/AppTopbar";
import Navbar from "./components/Navbar";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import Home from "./components/Home";
import { CompanyProvider } from "./context/CompanyContext";
import Pricing from "./components/Pricing";
import Features from "./components/Features";
import DownloadApp from "./components/DownloadApp";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService";
import DataProcessing from "./components/DataProcessing";
import Security from "./components/Security";
import Cookies from "./components/Cookies";
import CookieConsent from "./components/CookieConsent";
import DocsGuides from "./components/resources/DocsGuides";
import ApiReference from "./components/resources/ApiReference";
import Templates from "./components/resources/Templates";
import Status from "./components/resources/Status";
import Changelog from "./components/resources/Changelog";
import LogIn from "./components/login";
import SignUp from "./components/sign-up";
import ResetPassword from "./components/resetPassword";
import ResetPasswordUpdate from "./components/ResetPasswordUpdate";
import Support from "./components/Support";
import Contact from "./components/Contact";
import Onboarding from "./components/Onboarding";
import Dashboard from "./Product/dashboard";
import Customers from "./Product/customers";
import Vendors from "./Product/Vendors";
import AccountChart from "./Product/Accounting/account_chart";
import TotalJournals from "./Product/Accounting/TotalJournals";
import Report from "./Product/report";
import Income from "./Product/Accounting/income";
import SOFP from "./Product/Accounting/sofp";
import Estimate from "./Product/estimate";
import Invoice from "./Product/invoice";
import Receipt from "./Product/receipt";
import TotalEstimates from "./Product/total_estimate";
import TotalInvoices from "./Product/total_invoice";
import TotalReceipts from "./Product/totalReceipts";
import BillingPage from "./Product/billings";
import BillingCallback from "./Product/billingCallback";
import Settings from "./Product/settings";
import Transactions from "./Product/transactions";
import Journal from "./Product/Accounting/JournalForm";
import Reconcilliation from "./Product/Accounting/Reconcilliation";
import { CoAProvider } from "./context/CoAContext";
import "./Product/Accounting/styles.css";
import AccountLedger from "./Product/Accounting/AccountLedger";
import FixedAssetsList from "./Product/Accounting/FixedAssets/FixedAssetsList";
import FixedAssetForm from "./Product/Accounting/FixedAssets/FixedAssetForm";
import FixedAssetDetails from "./Product/Accounting/FixedAssets/FixedAssetDetails";
import FixedAssetCategories from "./Product/Accounting/FixedAssets/FixedAssetCategories";
import FixedAssetDepreciationRuns from "./Product/Accounting/FixedAssets/FixedAssetDepreciationRuns";
import FixedAssetRollForward from "./Product/Accounting/FixedAssets/FixedAssetRollForward";
import InventoryDashboard from "./Product/Inventory/InventoryDashboard";
import InventoryItems from "./Product/Inventory/InventoryItems";
import Warehouses from "./Product/Inventory/Warehouses";
import StockMovements from "./Product/Inventory/StockMovements";
import StockOnHand from "./Product/Inventory/StockOnHand";
import InventorySettings from "./Product/Inventory/InventorySettings";
import GeneralLedger from "./Product/Accounting/GeneralLedger";
import BankTransactions from "./Product/Accounting/BankTransactions";
import TrialBalance from "./Product/Accounting/TrialBalance";
import RequireOnboarding from "./components/RequireOnboarding";
import CashFlows from "./Product/Accounting/cashFlows";
import ManagementReport from "./Product/Accounting/ManagementReport";
import FinancialPacks from "./Product/Accounting/FinancialPacks";
import FinancialPackEditor from "./Product/Accounting/FinancialPackEditor";
import TeamSettings from "./Product/TeamSettings";
import AcceptInvite from "./Product/AcceptInvite";
import HelpWalkthroughModal from "./components/HelpWalkthroughModal";
import { supabase } from "./Services/supabaseClient";
import SalesQuickEntry from "./Product/SalesQuickEntry";
import PurchasesQuickEntry from "./Product/PurchasesQuickEntry";
import SalesHistory from "./Product/SalesHistory";
import PurchaseHistory from "./Product/PurchaseHistory";
import SaleDetail from "./Product/SaleDetail";
import PurchaseDetail from "./Product/PurchaseDetail";
import InventoryValuationReport from "./Product/InventoryValuationReport";
import StockAgeingReport from "./Product/StockAgeingReport";
import CustomerPayments from "./Product/Trade/CustomerPayments";
import VendorPayments from "./Product/Trade/VendorPayments";
import CustomersAging from "./Product/Trade/CustomersAging";
import VendorsAging from "./Product/Trade/VendorsAging";
import ARCustomers from "./Product/Accounting/Subledger/ARCustomers";
import APVendors from "./Product/Accounting/Subledger/APVendors";
import ARCustomerDetail from "./Product/Accounting/Subledger/ARCustomerDetail";
import APVendorDetail from "./Product/Accounting/Subledger/APVendorDetail";
import AllocationWorkspace from "./Product/Accounting/Subledger/AllocationWorkspace";
import ApprovalsQueue from "./Product/Accounting/Subledger/ApprovalsQueue";
import SchedulingHome from "./Product/Scheduling/SchedulingHome";
import Calendar from "./Product/Scheduling/Calendar";
import Finder from "./Product/Scheduling/Finder";
import Bookings from "./Product/Scheduling/BookingsList";
import Spaces from "./Product/Scheduling/Spaces";
import Audit from "./Product/Scheduling/Audit";
import Budgets from "./Product/Budget/Budgets";
import BudgetWorkspace from "./Product/Budget/BudgetWorkspace";
import ForecastBuilder from "./Product/Budget/ForecastBuilder";
import DriverLibrary from "./Product/Budget/DriverLibrary";
import FormulaManager from "./Product/Budget/FormulaManager";
import ScenarioManager from "./Product/Budget/ScenarioManager";
import TaxConfiguration from "./Product/tax/TaxConfiguration";
import TaxPeriods from "./Product/tax/TaxPeriods";
import TaxDashboard from "./Product/tax/TaxDashboard";
import VATCenter from "./Product/tax/VATCenter";
import WHTCenter from "./Product/tax/WHTCenter";
import CITCenter from "./Product/tax/CITCenter";
import DevelopmentLevyCenter from "./Product/tax/DevelopmentLevyCenter";
import TaxFilings from "./Product/tax/TaxFilings";
import PayrollLayout from "./Payroll/PayrollLayout";
import PayrollDashboard from "./Payroll/pages/PayrollDashboard";
import PayrollEmployees from "./Payroll/pages/PayrollEmployees";
import PayrollComponents from "./Payroll/pages/PayrollComponents";
import PayrollCalendars from "./Payroll/pages/PayrollCalendars";
import PayrollRuns from "./Payroll/pages/PayrollRuns";
import PayrollRunDetails from "./Payroll/pages/PayrollRunDetails";
import PayrollSettings from "./Payroll/pages/PayrollSettings";
import PayrollAttendance from "./Payroll/pages/PayrollAttendance";
import PayrollLeave from "./Payroll/pages/PayrollLeave";
import PayrollBenefits from "./Payroll/pages/PayrollBenefits";
import PayrollCompliance from "./Payroll/pages/PayrollCompliance";
import PayrollApprovals from "./Payroll/pages/PayrollApprovals";
import PayrollPayments from "./Payroll/pages/PayrollPayments";
import PayrollReports from "./Payroll/pages/PayrollReports";
import PayrollScenarios from "./Payroll/pages/PayrollScenarios";
import PayrollAnomalies from "./Payroll/pages/PayrollAnomalies";
import PayrollStructures from "./Payroll/pages/PayrollStructures";
import CRMLayout from "./crm/pages/CRMLayout";
import CRMWelcome from "./crm/pages/CRMWelcome";
import CRMDashboard from "./crm/pages/CRMDashboard";
import LeadsPage from "./crm/pages/LeadsPage";
import OpportunitiesPage from "./crm/pages/OpportunitiesPage";
import AccountDetailsPage from "./crm/pages/AccountDetailsPage";
import CollectionsPage from "./crm/pages/CollectionsPage";
import QuotesPage from "./crm/pages/QuotesPage";
import QuoteDetailsPage from "./crm/pages/QuoteDetailsPage";
import AccountsPage from "./crm/pages/AccountsPage";
import ContactsPage from "./crm/pages/ContactsPage";
import OpportunityDetailsPage from "./crm/pages/OpportunityDetailsPage";
import CRMSettingsPage from "./crm/pages/CRMSettingsPage";
import CRMForecastPage from "./crm/pages/CRMForecastPage";
import CreateOpportunityPage from "./crm/pages/CreateOpportunityPage";

function ProtectedRoute({ isLoggedIn, children }) {
  return isLoggedIn ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <CompanyProvider>
      <CoAProvider>
        <Router>
          <MainLayout />
        </Router>
        {localStorage.getItem("isLoggedIn") === "true" && <Chatbot />}
      </CoAProvider>
    </CompanyProvider>
  );
}

function MainLayout() {
  // State for managing login status
  const location = useLocation();
  const isOnboardingRoute = location.pathname === "/Onboarding";
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    const saved = localStorage.getItem("isLoggedIn");
    return saved === "true" ? true : false;
  });

  useEffect(() => {
    localStorage.setItem("isLoggedIn", isLoggedIn);
  }, [isLoggedIn]);

  const [userProfile, setUserProfile] = useState(null); // Store user profile

  // ---- Help Walkthrough (global for logged-in users) ----
  const [helpOpen, setHelpOpen] = useState(false);
  const [walkthroughChecked, setWalkthroughChecked] = useState(false);

  useEffect(() => {
    const run = async () => {
      // Only check after login
      if (!isLoggedIn || walkthroughChecked) return;

      const {
        data: { user },
      } = await supabase.auth.getUser();

      if (!user?.id) {
        setWalkthroughChecked(true);
        return;
      }

      // Check if user has seen walkthrough before
      const { data: profile, error } = await supabase
        .from("profiles")
        .select("has_seen_walkthrough")
        .eq("id", user.id)
        .maybeSingle();

      // If missing/NULL, treat as not seen (opens once)
      const hasSeen = profile?.has_seen_walkthrough === true;

      if (!error && !hasSeen) {
        setHelpOpen(true);
      }

      setWalkthroughChecked(true);
    };

    run();
  }, [isLoggedIn, walkthroughChecked]);

  // 1) Full-width onboarding
  if (isOnboardingRoute) {
    return (
      <Routes>
        <Route
          path="/Onboarding"
          element={
            <ProtectedRoute isLoggedIn={isLoggedIn}>
              <Onboarding />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/Onboarding" replace />} />
      </Routes>
    );
  }

  // 2) Public (pre-login) layout
  if (!isLoggedIn) {
    return (
      <>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/Support" element={<Support />} />
          <Route path="/Pricing" element={<Pricing />} />
          <Route path="/Features" element={<Features />} />
          <Route path="/download" element={<DownloadApp />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/data-processing" element={<DataProcessing />} />
          <Route path="/security" element={<Security />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/docs-guides" element={<DocsGuides />} />
          <Route path="/api-reference" element={<ApiReference />} />
          <Route path="/templates" element={<Templates />} />
          <Route path="/status" element={<Status />} />
          <Route path="/changelog" element={<Changelog />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/SignUp" element={<SignUp />} />
          <Route path="/ResetPassword" element={<ResetPassword />} />
          <Route
            path="/ResetPasswordUpdate"
            element={<ResetPasswordUpdate />}
          />
          <Route path="/accept-invite" element={<AcceptInvite />} />
          <Route
            path="/login"
            element={
              <LogIn
                setIsLoggedIn={setIsLoggedIn}
                setUserProfile={setUserProfile}
              />
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <CookieConsent />
      </>
    );
  }

  const isPayrollRoute = location.pathname.startsWith("/payroll");

  if (isPayrollRoute) {
    return (
      <>
        <HelpWalkthroughModal
          open={helpOpen}
          onOpen={() => setHelpOpen(true)}
          onClose={async () => {
            setHelpOpen(false);

            const {
              data: { user },
            } = await supabase.auth.getUser();

            if (user?.id) {
              await supabase
                .from("profiles")
                .upsert(
                  { id: user.id, has_seen_walkthrough: true },
                  { onConflict: "id" },
                );
            }
          }}
          pathname={location.pathname}
        />

        <button
          type="button"
          className="kp-help-fab"
          onClick={() => setHelpOpen(true)}
          title="Help / Walkthrough"
        >
          Help
        </button>

        <Routes>
          <Route
            path="/payroll"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="Payroll">
                    <PayrollLayout />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route
              path="dashboard"
              element={
                <ProtectedRoute isLoggedIn={isLoggedIn}>
                  <RequireRole>
                    <RequirePlan min="business" featureName="Payroll Dashboard">
                      <PayrollDashboard />
                    </RequirePlan>
                  </RequireRole>
                </ProtectedRoute>
              }
            />
            <Route
              path="employees"
              element={
                <ProtectedRoute isLoggedIn={isLoggedIn}>
                  <RequireRole>
                    <RequirePlan min="business" featureName="Payroll Employees">
                      <PayrollEmployees />
                    </RequirePlan>
                  </RequireRole>
                </ProtectedRoute>
              }
            />
            <Route
              path="components"
              element={
                <ProtectedRoute isLoggedIn={isLoggedIn}>
                  <RequireRole>
                    <RequirePlan
                      min="business"
                      featureName="Payroll Components"
                    >
                      <PayrollComponents />
                    </RequirePlan>
                  </RequireRole>
                </ProtectedRoute>
              }
            />
            <Route
              path="attendance"
              element={
                <ProtectedRoute isLoggedIn={isLoggedIn}>
                  <RequireRole>
                    <RequirePlan
                      min="business"
                      featureName="Payroll Attendance"
                    >
                      <PayrollAttendance />
                    </RequirePlan>
                  </RequireRole>
                </ProtectedRoute>
              }
            />

            <Route
              path="leave"
              element={
                <ProtectedRoute isLoggedIn={isLoggedIn}>
                  <RequireRole>
                    <RequirePlan min="business" featureName="Payroll Leave">
                      <PayrollLeave />
                    </RequirePlan>
                  </RequireRole>
                </ProtectedRoute>
              }
            />

            <Route
              path="benefits"
              element={
                <ProtectedRoute isLoggedIn={isLoggedIn}>
                  <RequireRole>
                    <RequirePlan min="business" featureName="Payroll Benefits">
                      <PayrollBenefits />
                    </RequirePlan>
                  </RequireRole>
                </ProtectedRoute>
              }
            />
            <Route
              path="calendars"
              element={
                <ProtectedRoute isLoggedIn={isLoggedIn}>
                  <RequireRole>
                    <RequirePlan min="business" featureName="Payroll Calendars">
                      <PayrollCalendars />
                    </RequirePlan>
                  </RequireRole>
                </ProtectedRoute>
              }
            />
            <Route
              path="compliance"
              element={
                <ProtectedRoute isLoggedIn={isLoggedIn}>
                  <RequireRole>
                    <RequirePlan
                      min="business"
                      featureName="Payroll Compliance"
                    >
                      <PayrollCompliance />
                    </RequirePlan>
                  </RequireRole>
                </ProtectedRoute>
              }
            />

            <Route
              path="runs"
              element={
                <ProtectedRoute isLoggedIn={isLoggedIn}>
                  <RequireRole>
                    <RequirePlan min="business" featureName="Payroll Runs">
                      <PayrollRuns />
                    </RequirePlan>
                  </RequireRole>
                </ProtectedRoute>
              }
            />
            <Route
              path="runs/:runId"
              element={
                <ProtectedRoute isLoggedIn={isLoggedIn}>
                  <RequireRole>
                    <RequirePlan
                      min="business"
                      featureName="Payroll Run Details"
                    >
                      <PayrollRunDetails />
                    </RequirePlan>
                  </RequireRole>
                </ProtectedRoute>
              }
            />
            <Route
              path="approvals"
              element={
                <ProtectedRoute isLoggedIn={isLoggedIn}>
                  <RequireRole>
                    <RequirePlan min="business" featureName="Payroll Approvals">
                      <PayrollApprovals />
                    </RequirePlan>
                  </RequireRole>
                </ProtectedRoute>
              }
            />

            <Route
              path="payments"
              element={
                <ProtectedRoute isLoggedIn={isLoggedIn}>
                  <RequireRole>
                    <RequirePlan min="business" featureName="Payroll Payments">
                      <PayrollPayments />
                    </RequirePlan>
                  </RequireRole>
                </ProtectedRoute>
              }
            />

            <Route
              path="reports"
              element={
                <ProtectedRoute isLoggedIn={isLoggedIn}>
                  <RequireRole>
                    <RequirePlan min="business" featureName="Payroll Reports">
                      <PayrollReports />
                    </RequirePlan>
                  </RequireRole>
                </ProtectedRoute>
              }
            />

            <Route
              path="scenarios"
              element={
                <ProtectedRoute isLoggedIn={isLoggedIn}>
                  <RequireRole>
                    <RequirePlan min="business" featureName="Payroll Scenarios">
                      <PayrollScenarios />
                    </RequirePlan>
                  </RequireRole>
                </ProtectedRoute>
              }
            />

            <Route
              path="anomalies"
              element={
                <ProtectedRoute isLoggedIn={isLoggedIn}>
                  <RequireRole>
                    <RequirePlan min="business" featureName="Payroll Anomalies">
                      <PayrollAnomalies />
                    </RequirePlan>
                  </RequireRole>
                </ProtectedRoute>
              }
            />
            <Route
              path="structures"
              element={
                <ProtectedRoute isLoggedIn={isLoggedIn}>
                  <RequireRole>
                    <RequirePlan
                      min="business"
                      featureName="Payroll Structures"
                    >
                      <PayrollStructures />
                    </RequirePlan>
                  </RequireRole>
                </ProtectedRoute>
              }
            />

            <Route
              path="settings"
              element={
                <ProtectedRoute isLoggedIn={isLoggedIn}>
                  <RequireRole>
                    <RequirePlan min="business" featureName="Payroll Settings">
                      <PayrollSettings />
                    </RequirePlan>
                  </RequireRole>
                </ProtectedRoute>
              }
            />
          </Route>

          <Route
            path="*"
            element={<Navigate to="/payroll/dashboard" replace />}
          />
        </Routes>
      </>
    );
  }

  const isCRMRoute = location.pathname.startsWith("/crm");

  if (isCRMRoute) {
    return (
      <>
        <HelpWalkthroughModal
          open={helpOpen}
          onOpen={() => setHelpOpen(true)}
          onClose={async () => {
            setHelpOpen(false);

            const {
              data: { user },
            } = await supabase.auth.getUser();

            if (user?.id) {
              await supabase
                .from("profiles")
                .upsert(
                  { id: user.id, has_seen_walkthrough: true },
                  { onConflict: "id" },
                );
            }
          }}
          pathname={location.pathname}
        />

        <button
          type="button"
          className="kp-help-fab"
          onClick={() => setHelpOpen(true)}
          title="Help / Walkthrough"
        >
          Help
        </button>

        <Routes>
          <Route
            path="/crm"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="CRM">
                    <CRMLayout />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          >
            <Route
              index
              element={
                <ProtectedRoute isLoggedIn={isLoggedIn}>
                  <RequireRole>
                    <RequirePlan min="business" featureName="CRM Welcome">
                      <CRMWelcome />
                    </RequirePlan>
                  </RequireRole>
                </ProtectedRoute>
              }
            />

            <Route
              path="dashboard"
              element={
                <ProtectedRoute isLoggedIn={isLoggedIn}>
                  <RequireRole>
                    <RequirePlan min="business" featureName="CRM Dashboard">
                      <CRMDashboard />
                    </RequirePlan>
                  </RequireRole>
                </ProtectedRoute>
              }
            />

            <Route
              path="leads"
              element={
                <ProtectedRoute isLoggedIn={isLoggedIn}>
                  <RequireRole>
                    <RequirePlan min="business" featureName="CRM Leads">
                      <LeadsPage />
                    </RequirePlan>
                  </RequireRole>
                </ProtectedRoute>
              }
            />

            <Route
              path="opportunities"
              element={
                <ProtectedRoute isLoggedIn={isLoggedIn}>
                  <RequireRole>
                    <RequirePlan min="business" featureName="CRM Opportunities">
                      <OpportunitiesPage />
                    </RequirePlan>
                  </RequireRole>
                </ProtectedRoute>
              }
            />
            <Route
              path="opportunities/new"
              element={
                <ProtectedRoute isLoggedIn={isLoggedIn}>
                  <RequireRole>
                    <RequirePlan
                      min="business"
                      featureName="Create Opportunity"
                    >
                      <CreateOpportunityPage />
                    </RequirePlan>
                  </RequireRole>
                </ProtectedRoute>
              }
            />

            <Route
              path="opportunities/:opportunityId"
              element={
                <ProtectedRoute isLoggedIn={isLoggedIn}>
                  <RequireRole>
                    <RequirePlan
                      min="business"
                      featureName="Opportunities Details"
                    >
                      <OpportunityDetailsPage />
                    </RequirePlan>
                  </RequireRole>
                </ProtectedRoute>
              }
            />

            <Route
              path="accounts/:accountId"
              element={
                <ProtectedRoute isLoggedIn={isLoggedIn}>
                  <RequireRole>
                    <RequirePlan
                      min="business"
                      featureName="CRM Account Details"
                    >
                      <AccountDetailsPage />
                    </RequirePlan>
                  </RequireRole>
                </ProtectedRoute>
              }
            />

            <Route
              path="collections"
              element={
                <ProtectedRoute isLoggedIn={isLoggedIn}>
                  <RequireRole>
                    <RequirePlan min="business" featureName="CRM Collections">
                      <CollectionsPage />
                    </RequirePlan>
                  </RequireRole>
                </ProtectedRoute>
              }
            />
            <Route
              path="quotes"
              element={
                <ProtectedRoute isLoggedIn={isLoggedIn}>
                  <RequireRole>
                    <RequirePlan min="business" featureName="Quotes Page">
                      <QuotesPage />
                    </RequirePlan>
                  </RequireRole>
                </ProtectedRoute>
              }
            />
            <Route
              path="quotes/:quoteId"
              element={
                <ProtectedRoute isLoggedIn={isLoggedIn}>
                  <RequireRole>
                    <RequirePlan min="business" featureName="Quote Detail Page">
                      <QuoteDetailsPage />
                    </RequirePlan>
                  </RequireRole>
                </ProtectedRoute>
              }
            />
            <Route
              path="accounts"
              element={
                <ProtectedRoute isLoggedIn={isLoggedIn}>
                  <RequireRole>
                    <RequirePlan min="business" featureName="Accounts Page">
                      <AccountsPage />
                    </RequirePlan>
                  </RequireRole>
                </ProtectedRoute>
              }
            />
            <Route
              path="contacts"
              element={
                <ProtectedRoute isLoggedIn={isLoggedIn}>
                  <RequireRole>
                    <RequirePlan min="business" featureName="Contacts Page">
                      <ContactsPage />
                    </RequirePlan>
                  </RequireRole>
                </ProtectedRoute>
              }
            />
            <Route
              path="forecast"
              element={
                <ProtectedRoute isLoggedIn={isLoggedIn}>
                  <RequireRole>
                    <RequirePlan min="business" featureName="Forecast Page">
                      <CRMForecastPage />
                    </RequirePlan>
                  </RequireRole>
                </ProtectedRoute>
              }
            />
            <Route
              path="settings"
              element={
                <ProtectedRoute isLoggedIn={isLoggedIn}>
                  <RequireRole>
                    <RequirePlan min="business" featureName="Settings Page">
                      <CRMSettingsPage />
                    </RequirePlan>
                  </RequireRole>
                </ProtectedRoute>
              }
            />

            <Route path="*" element={<Navigate to="/crm" replace />} />
          </Route>

          <Route path="*" element={<Navigate to="/crm" replace />} />
        </Routes>
      </>
    );
  }

  // 3) Private (post-login) layout with sidebar
  return (
    <div className="app-layout">
      <div className="sidebar-container">
        <Sidebar setIsLoggedIn={setIsLoggedIn} />
      </div>
      <main className="main-content">
        <AppTopbar />

        {/* Help Walkthrough Modal (available everywhere post-login) */}
        <HelpWalkthroughModal
          open={helpOpen}
          onOpen={() => setHelpOpen(true)}
          onClose={async () => {
            setHelpOpen(false);

            // Mark as "seen" so it doesn't auto-open again
            const {
              data: { user },
            } = await supabase.auth.getUser();

            if (user?.id) {
              await supabase
                .from("profiles")
                .upsert(
                  { id: user.id, has_seen_walkthrough: true },
                  { onConflict: "id" },
                );
            }
          }}
          pathname={location.pathname}
        />

        {/* Floating Help button (always accessible after login) */}
        <button
          type="button"
          className="kp-help-fab"
          onClick={() => setHelpOpen(true)}
          title="Help / Walkthrough"
        >
          Help
        </button>

        <Routes>
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequireOnboarding>
                    <Dashboard userProfile={userProfile} />
                  </RequireOnboarding>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/Onboarding"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <Onboarding />
              </ProtectedRoute>
            }
          />
          <Route
            path="/customers"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <Customers />
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/vendors"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                {/* ✅ Vendors should be SME+ */}
                <RequireRole>
                  <RequirePlan min="sme" featureName="Vendors">
                    <Vendors />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />

          {/* ✅ Quick Entries:
              - Sales Quick = Starter+
              - Purchases Quick = SME+
          */}
          <Route
            path="/sales-quick"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="starter" featureName="Sales-Quick">
                    <SalesQuickEntry />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/purchases-quick"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="sme" featureName="Purchases-Quick">
                    <PurchasesQuickEntry />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />

          {/* ✅ Histories (SME+) */}
          <Route
            path="/sales-history"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="sme" featureName="Sales-History">
                    <SalesHistory />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/purchase-history"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="sme" featureName="Purchase-History">
                    <PurchaseHistory />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/sales/:id"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="sme" featureName="Sales-ID">
                    <SaleDetail />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/purchase/:id"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="sme" featureName="Purchase-ID">
                    <PurchaseDetail />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />

          {/* ✅ Trade / payments / aging (SME+) */}
          <Route
            path="/customer/:customerId/payments"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="sme" featureName="Customer-Payment-ID">
                    <CustomerPayments />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/vendor/:vendorId/payments"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="sme" featureName="Vendor-Payment-ID">
                    <VendorPayments />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/customers/aging"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="Customers Aging">
                    <CustomersAging />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/vendors/aging"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="Vendors Aging">
                    <VendorsAging />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />

          {/* ✅ Inventory Valuation / Stock Ageing = Business */}
          <Route
            path="/inventory-valuation"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="Inv-Valuation">
                    <InventoryValuationReport />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/stock-ageing"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="Stock Ageing">
                    <StockAgeingReport />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />

          <Route
            path="/report"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <Report />
                </RequireRole>
              </ProtectedRoute>
            }
          />

          {/* ✅ Create Documents (Starter+) */}
          <Route
            path="/estimate"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="starter" featureName="Estimates">
                    <Estimate />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/invoice"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="free" featureName="Invoice">
                    <Invoice />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />

          {/* ⚠ Keeping your existing routes intact as requested, but fixing plan gate only */}
          <Route
            path="/invoice/:id"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                {/* NOTE: Your code had "Invoice Form" which is invalid JSX.
                    Not changing structure/features here as requested. */}
                <RequireRole>
                  <RequirePlan min="free" featureName="Invoice Edit">
                    <Invoice />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />

          <Route
            path="/receipt"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="starter" featureName="Receipt">
                    <Receipt />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />

          <Route
            path="/receipt/:id"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                {/* NOTE: Your code had "Receipt Form" which is invalid JSX.
                    Not changing structure/features here as requested. */}
                <RequireRole>
                  <RequirePlan min="starter" featureName="Receipt Edit">
                    <Receipt />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />

          {/* ✅ Journal should be Business (finance-mature tool) */}
          <Route
            path="/journal"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="Journal">
                    <Journal />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />

          {/* ✅ Bank & Recon should be Business */}
          <Route
            path="/BankTransactions"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="Bank Transactions">
                    <BankTransactions />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/chart-of-accounts"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="Chart of Accounts">
                    <AccountChart />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/total_journals"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="sme" featureName="Journals">
                    <TotalJournals />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />

          <Route
            path="/Reconcilliation"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="Reconciliation">
                    <Reconcilliation />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />

          {/* ✅ Keep duplicates but align plan to new tiers (do not remove existing code) */}
          <Route
            path="/sales-quick"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="starter" featureName="sales-quick">
                    <SalesQuickEntry />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/purchases-quick"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="sme" featureName="purchases-quick">
                    <PurchasesQuickEntry />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />

          {/* Fixed Assets (Business) */}
          <Route
            path="/fixed-assets"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="fixed-assets">
                    <FixedAssetsList />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/fixed-assets/new"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="fixed-assets-new">
                    <FixedAssetForm />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/fixed-assets/fixed-assets/:assetId"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="fixed-assetsId">
                    <FixedAssetDetails />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/fixed-assets/fixed-assets/:assetId/edit"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="fixed-assetsId-edit">
                    <FixedAssetForm />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/fixed-assets/fixed-asset-categories"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan
                    min="business"
                    featureName="fixed-assets-categories"
                  >
                    <FixedAssetCategories />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/fixed-assets/fixed-asset-depreciation-runs"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan
                    min="business"
                    featureName="fixed-assets-depreciation-runs"
                  >
                    <FixedAssetDepreciationRuns />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/fixed-assets/fixed-asset-rollforward"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan
                    min="business"
                    featureName="fixed-assets-rollforward"
                  >
                    <FixedAssetRollForward />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />

          {/* Inventory (SME+)
              ✅ IMPORTANT: inventory pages were blank because they were gated as Business.
              SME plan must access Inventory Dashboard + Items + Movements + Stock On Hand.
              Warehouses/Settings can stay Business-only if you want.
          */}
          <Route
            path="/inventory"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="sme" featureName="inventory-dashboard">
                    <InventoryDashboard />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />

          <Route
            path="/inventory/items"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="sme" featureName="inventory-items">
                    <InventoryItems />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />

          <Route
            path="/inventory/warehouses"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan
                    min="business"
                    featureName="inventory-warehouses"
                  >
                    <Warehouses />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />

          <Route
            path="/inventory/movements"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="sme" featureName="inventory-movements">
                    <StockMovements />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />

          <Route
            path="/inventory/stock-on-hand"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="sme" featureName="stock-on-hand">
                    <StockOnHand />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />

          <Route
            path="/inventory/settings"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireAdminRole>
                  <RequirePlan min="business" featureName="inventory-settings">
                    <InventorySettings />
                  </RequirePlan>
                </RequireAdminRole>
              </ProtectedRoute>
            }
          />

          {/* Totals (Starter+) */}
          <Route
            path="/total_estimate"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="starter" featureName="All Estimates">
                    <TotalEstimates />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/total_invoice"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="starter" featureName="All Invoices">
                    <TotalInvoices />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/totalReceipts"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="starter" featureName="All Receipts">
                    <TotalReceipts />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />

          {/* Reports:
              - Income + Cashflows are SME
              - SOFP and advanced ledgers are Business
          */}
          <Route
            path="/income"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="sme" featureName="Income Report">
                    <Income />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/account-ledger"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="AccountLedger">
                    <AccountLedger />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/sofp"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="SOFP">
                    <SOFP />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/cashFlows"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="sme" featureName="Cashflows">
                    <CashFlows />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/managementReport"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="Management Report">
                    <ManagementReport />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/packs"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="Financial Pack">
                    <FinancialPacks />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/packs/:packId"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan
                    min="business"
                    featureName="Financial Pack Editor"
                  >
                    <FinancialPackEditor />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/subledger/ar"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="AR Customers">
                    <ARCustomers />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/subledger/ar/:customerId"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="AR Customer Id">
                    <ARCustomerDetail />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/subledger/ap"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="AP Vendors">
                    <APVendors />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/subledger/ap/:vendorId"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="AP Vendor Detail">
                    <APVendorDetail />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/ar/allocations"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan
                    min="business"
                    featureName="Allocation Workspace"
                  >
                    <AllocationWorkspace ledger="AR" />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/ap/allocations"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan
                    min="business"
                    featureName="Allocation Workspace"
                  >
                    <AllocationWorkspace ledger="AP" />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/approvals"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="Approvals Queue">
                    <ApprovalsQueue />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/GeneralLedger"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="General Ledger">
                    <GeneralLedger />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/TrialBalance"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="Trial Balance">
                    <TrialBalance />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />

          {/* Billing / Settings */}
          <Route
            path="/billings"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireAdminRole>
                  <BillingPage />
                </RequireAdminRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/billing/callback"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireAdminRole>
                  <BillingCallback />
                </RequireAdminRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <Settings />
                </RequireRole>
              </ProtectedRoute>
            }
          />

          {/* Team Settings + Transactions should be Business */}
          <Route
            path="/team-settings"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireAdminRole>
                  <RequirePlan min="business" featureName="TeamSettings">
                    <TeamSettings />
                  </RequirePlan>
                </RequireAdminRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/transactions"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="Transactions">
                    <Transactions />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/scheduling"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="Scheduling">
                    <SchedulingHome />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/calendar"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="Calendar">
                    <Calendar />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/finder"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="Finder">
                    <Finder />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/bookings"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="Bookings">
                    <Bookings />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/spaces"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="Spaces">
                    <Spaces />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/audit"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="Audit">
                    <Audit />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/budgets"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="Budget">
                    <Budgets />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/budget/:id"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="Budget Workspace">
                    <BudgetWorkspace />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/forecast-builder"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="Forecast Builder">
                    <ForecastBuilder />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/driver-library"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="Driver Library">
                    <DriverLibrary />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/formula-manager"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="Formula Manager">
                    <FormulaManager />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/scenario-manager"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="Scenario Manager">
                    <ScenarioManager />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/tax"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="Tax Dashboard">
                    <TaxDashboard />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/tax/configuration"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="Tax Configuration">
                    <TaxConfiguration />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/tax/periods"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="Tax Periods">
                    <TaxPeriods />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/tax/vat"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="VAT Center">
                    <VATCenter />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/tax/wht"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="WHT Center">
                    <WHTCenter />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/tax/cit"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="CIT Center">
                    <CITCenter />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/tax/development-levy"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan
                    min="business"
                    featureName="Development Levy Center"
                  >
                    <DevelopmentLevyCenter />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />
          <Route
            path="/tax/filings"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <RequireRole>
                  <RequirePlan min="business" featureName="Tax Dashboard">
                    <TaxFilings />
                  </RequirePlan>
                </RequireRole>
              </ProtectedRoute>
            }
          />

          <Route
            path="*"
            element={
              isLoggedIn ? (
                <Navigate to="/dashboard" replace />
              ) : (
                <Navigate to="/" replace />
              )
            }
          />
        </Routes>
      </main>
    </div>
  );
}

export default App;
